/* global window */

import log from 'loglevel';

const settings = {
  defaultLogLevel: log.levels.DEBUG,
  timeout: 5000,
  sessionLength: 1000 * 60 * 30,

  braze: {
    scripts: [],
    allowUserSuppliedJavascript: true,
  },

  ...window.METAPHOR_SETTINGS,
};

export default settings;



// WEBPACK FOOTER //
// ./src/settings.js